import { useEffect, useState } from "react";
import http from "../utils/http";
import { errorToastMessage } from "../utils/toast";
import {
  RegistryFilterMeta,
} from "../utils/registryColumnFilters";
import { FilterOption } from "../Components/Common/UI/columnFilterTypes";

export function useRegistryFilterOptions() {
  const [filterMeta, setFilterMeta] = useState<
    Record<string, RegistryFilterMeta>
  >({});
  const [tagList, setTagList] = useState<{ id: string; label: string }[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [langRes, filtersRes, tagsRes] = await Promise.all([
          http.get(`/admin/registry/settings/languages`),
          http.get(`/admin/registry/participants/filters`),
          http.get(`/platform-tags`),
        ]);
        const resData = langRes?.data?.data;
        const languageOptions: FilterOption[] = resData.map((lang: any) => ({
          value: lang.languageCode,
          label: lang.languageLabel,
        }));
        const data = filtersRes.data.data;
        const meta: Record<string, RegistryFilterMeta> = {};
        Object.entries(data).forEach(([key, value]: [string, any]) => {
          if (key === "lang") {
            meta[key] = {
              filter: key,
              label: value.label,
              type: value.type,
              options: languageOptions,
            };
          } else {
            meta[key] = {
              filter: key,
              label: value.label,
              type: value.type,
              options: value.options,
            };
          }
        });
        setFilterMeta(meta);

        const tagData = tagsRes.data?.data?.map((item: any) => ({
          id: item?.id,
          label: item?.name || "",
        }));
        setTagList(tagData || []);
      } catch (error) {
        errorToastMessage(error as Error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return { filterMeta, tagList, loading };
}
